import {useEffect,useRef,useState} from "react";
import {api} from "./api";
import {useAuth} from "@/context/AuthContext";
export function useExecutionPolicy(){
 const auth=useAuth(),scope=auth?.user?.id||"current-session";
 const [policy,setPolicy]=useState({scope:null,direct:false,loading:true});
 useEffect(()=>{let live=true;setPolicy({scope,direct:false,loading:true});api.get("/settings").then(r=>{if(live)setPolicy({scope,direct:r.data?.execution?.confirmations==="off",loading:false})}).catch(()=>{if(live)setPolicy({scope,direct:false,loading:false})});return()=>{live=false}},[scope]);
 return {direct:policy.scope===scope&&policy.direct,loading:policy.scope!==scope||policy.loading};
}

export function requestId(){
 if(globalThis.crypto?.randomUUID)return globalThis.crypto.randomUUID();
 const a=new Uint8Array(16);globalThis.crypto.getRandomValues(a);a[6]=(a[6]&15)|64;a[8]=(a[8]&63)|128;
 return [...a].map((v,i)=>([4,6,8,10].includes(i)?"-":"")+v.toString(16).padStart(2,"0")).join("");
}
export function useDirectSubmission(){
 const pending=useRef(new Map());
 return async(path,payload,suffix="execute")=>{
  const key=path+"/"+suffix+JSON.stringify(payload);
  const id=pending.current.get(key)||requestId();pending.current.set(key,id);
  const result=await api.post(path+"/"+suffix,{request_id:id,payload});
  pending.current.delete(key);
  return result;
 };
}
export function executionNotice(response){
 if(response?.data?.requires_review)return "Propuesta preparada; revisá y aprobá la operación exacta antes de ejecutarla.";
 const r=response?.data?.result||response?.data||{};
 if(r.sent)return "Gmail aceptó el envío. Entrega al destinatario sin confirmar.";
 if(r.draft)return "Gmail aceptó el borrador.";
 if(r.accepted_by_client)return "WhatsApp aceptó el mensaje. Entrega al destinatario sin confirmar.";
 return r.verified?"Operación comprobada en el proveedor.":"Solicitud aceptada. Revisá el resultado final en la plataforma.";
}
